export default "__VITE_ASSET__bac960de__"